import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const spireonConfig: TSPConfig = {
  key: 'spireon',
  name: 'Spireon',
  category: TSPCategory.CUSTOM,
  helpText:
    'Please input the credentials you use to log into the Spireon Web App. For the API key, please contact your Spireon representative.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        { label: 'Username', name: 'username', type: 'text', required: true },
        {
          label: 'Password',
          name: 'password',
          type: 'password',
          required: true,
        },
        { label: 'API Key', name: 'apikey', type: 'text', required: true },
      ]}
    />
  ),
};

export default spireonConfig;
